import React from 'react';
import './ExternalLink.css';
import { Icon } from '../Icon/Icon';
import { IconName } from '../Icon/IconName';

export interface Props {
  url: string;
  showUrl?: boolean;
  icon?: IconName;
}

export function ExternalLink({ url, showUrl, icon = 'external-link--sm' }: Props): JSX.Element {
  return (
    <a href={url} target="_blank" rel="noreferrer">
      <span className="external-link__url">{showUrl && url}</span>
      <Icon className="external-link__icon" name={icon} />
    </a>
  );
}
